import { Button } from '@/components/Button/Button'
import { Loader } from '@/components/Loader/Loader'
import { Popup } from '@/components/Popup/Popup'
import { GeneratorFormContext } from '@/hooks/useGeneratorForm'
import { useProjectsState } from '@/state/projects'
import type { FunctionalComponent } from 'preact'
import { useContext, useState } from 'preact/hooks'
import { useShallow } from 'zustand/shallow'

export const DeleteProject: FunctionalComponent<{
  onCancel: () => void
  onSuccess: () => void
}> = props => {
  const form = useContext(GeneratorFormContext)!
  const projectFromStore = useProjectsState(useShallow(
    s => s.list.find(item => item.id === form.projectId),
  ))

  const [project] = useState(projectFromStore)

  const removeProject = useProjectsState(s => s.remove)
  const fetchProjects = useProjectsState(s => s.fetch)

  const [loading, setLoading] = useState(false)

  return (
    <>
      <Popup.Title>
        Delete {project?.title ?? 'project'}?
      </Popup.Title>

      <Popup.Fields>
        <Popup.Msg>
          All posts associated with "{project?.title ?? 'project'}" will be permanently deleted.
        </Popup.Msg>
      </Popup.Fields>

      <Popup.Footer>
        <div />
        <Popup.Buttons>
          <Button
            onClick={props.onCancel}
          >
            Cancel
          </Button>
          <Button
            type='primary'
            disabled={loading}
            onClick={async () => {
              try {
                setLoading(true)
                if (!project?.id) throw new Error('Project must be defined')
                await removeProject(project?.id)
                await fetchProjects()
                form.setProjectId(null)
                props.onSuccess()
              }
              catch (e) {
                console.error(e)
              }
              finally {
                setLoading(false)
              }
            }}
          >
            Delete
            {loading && (
              <>
                {' '}
                <Loader />
              </>
            )}
          </Button>
        </Popup.Buttons>
      </Popup.Footer>
    </>
  )
}
